module.exports = __webpack_public_path__ + "static/mask-6ff83ce0047c45204d0d419240c36e54.jpg";